import { getShortLanguageCode } from '../shortLanguageCode';
import { SUPPORTED_FIVERR_LOCALES_MAP, DEFAULT_FIVERR_LOCALE as DEFAULT_FIVERR_LOCALE_CONST } from './constants';

export const DEFAULT_FIVERR_LOCALE = DEFAULT_FIVERR_LOCALE_CONST;
export const SUPPORTED_FIVERR_LOCALES = Object.keys(SUPPORTED_FIVERR_LOCALES_MAP);
export const DEFAULT_FIVERR_LANGUAGE = getShortLanguageCode(DEFAULT_FIVERR_LOCALE);

/**
 * Build a map of the supported Fiverr locales in the form of:
 * {
 *     EN_US: 'en-US',
 *     DE_DE: 'de-DE',
 *     ES: 'es,
 *     ...
 * }
 * So consumers can check for specific locale in their code.
 * @returns {{localeKey: String}} - the native name of the locale
 */
const localesKeys = {};
Object.keys(SUPPORTED_FIVERR_LOCALES_MAP).forEach((locale) => {
    const localeKey = locale.toUpperCase().replace(/-/g, '_');
    localesKeys[localeKey] = locale;
});
export const SUPPORTED_FIVERR_LOCALES_KEYS = localesKeys;

/**
 * Check if Fiverr supports this locale.
 * Meaning: we have a Fiverr experience in this locale (UI language).
 * @param locale {string} - check for existence as-is, no trimming, etc.
 * @returns {boolean} - the locale is supported or not
 */
export const isSupportedFiverrLocale = (locale) => !!SUPPORTED_FIVERR_LOCALES_MAP[locale];

/**
 * Returns the native name of the locale.
 * @param locale {string} - check for existence as-is, no trimming, etc.
 * @returns {string} - the native name of the locale
 */
export const getFiverrLocaleNativeName = (locale) => SUPPORTED_FIVERR_LOCALES_MAP[locale] || locale;
